import { BoardEffects } from './modules/issues/store/board/board.effects';
import { ProcessEffects } from './modules/processes/store/process.effects';
import { MonitoringEffects } from './modules/project-monitoring/store/monitoring.effects';
import { ProjectTagsEffects } from './store/project-tags/project-tags.effects';
import { ProjectsEffects } from './store/projects/projects.effects';

export const projectEffects = [ProjectsEffects, ProjectTagsEffects, MonitoringEffects, BoardEffects, ProcessEffects];
